import React, { Component } from 'react';

export default class Portfolio extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="portfolio">
			<div className="row">
				<div className="twelve columns collapsed">
					<h1>Here are my achievements</h1>
					
					<div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
						<div className="columns portfolio-item">
							<div> 
								<h6>Secret Faces Biography</h6>								
								<a href="http://bio.secretfaces.be/" alt="Secret Faces Biography">
									<img alt src="images/portfolio/sfbio.jpg" />								
								</a>
							</div>
						</div> 
						  
						  
						<div className="columns portfolio-item">
							<div> 
								<h6>Home Sweet Home Design</h6>								
								<a href="http://homesweethomedesign.gabriel-cassano.be/" alt="Home Sweet Home Design">
									<img alt src="images/portfolio/hsh.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>I Love JavaScript</h6>								
								<a href="http://ilovejs.gabriel-cassano.be/" alt="I Love JavaScript">
									<img alt src="images/portfolio/javascript.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Guitar Learning</h6>								
								<a href="http://guitarlearning.gabriel-cassano.be/" alt="Guitar Learning">
									<img alt src="images/portfolio/guitarlearning.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Développement informatique</h6>								
								<a href="http://developpementinformatique.gabriel-cassano.be/" alt="Développement informatique">
									<img alt src="images/portfolio/devinf.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Secret Faces</h6>								
								<a href="http://www.secretfaces.be/" alt="Secret Faces">
									<img alt src="images/portfolio/secretfaces.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Easily learn to cook</h6>								
								<a href="http://eltc.gabriel-cassano.be/" alt="Easily Learn To Cook">
									<img alt src="images/portfolio/easily.jpg" />								
								</a>
							</div>
						</div>	

						<div className="columns portfolio-item">
							<div> 
								<h6>My Lower Price Shop</h6>								
								<a href="http://mylpsh.gabriel-cassano.be/fr/" alt="My Lower Price Shop">
									<img alt src="images/portfolio/mylowerpriceshop.jpg" />								
								</a>
							</div>
						</div>	
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Reading passion</h6>								
								<a href="http://readingpassion.gabriel-cassano.be/" alt="Reading passion">
									<img alt src="images/portfolio/readingpassion.jpg" />								
								</a>
							</div>
						</div>	
						
						<div className="columns portfolio-item">
							<div> 
								<h6>I love movies</h6>								
								<a href="http://ilovemovies.gabriel-cassano.be/" alt="I love movies">
									<img alt src="images/portfolio/ilovemovies.jpg" />								
								</a>
							</div>
						</div>	
						
						<div className="columns portfolio-item">
							<div> 
								<h6>My cd collection</h6>								
								<a href="http://mycdcollection.gabriel-cassano.be/public/" alt="My cd collection">
									<img alt src="images/portfolio/musiccollection.jpg" />								
								</a>
							</div>
						</div>	
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Music maniac</h6>								
								<a href="http://musicmaniac.gabriel-cassano.be/" alt="Music maniac">
									<img alt src="images/portfolio/musicmaniac.jpg" />								
								</a>
							</div>
						</div>	

						<div className="columns portfolio-item">
							<div> 
								<h6>Movies library</h6>								
								<a href="http://movieslibrary.gabriel-cassano.be/" alt="Movies library">
									<img alt src="images/portfolio/movieslibrary.jpg" />								
								</a>
							</div>
						</div>	

						<div className="columns portfolio-item">
							<div> 
								<h6>Invoking Demons</h6>								
								<a href="http://invokingdemons.gabriel-cassano.be/" alt="Invoking Demons">
									<img alt src="images/portfolio/invokingdemons.jpg" />								
								</a>
							</div>
						</div>
							
						<div className="columns portfolio-item">
							<div> 
								<h6>Katassamalass</h6>								
								<a href="http://www.katassamalass.eu/" alt="Katassamalass">
									<img alt src="images/portfolio/katassamalass.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>My music shop</h6>								
								<a href="http://musicshop.gabriel-cassano.be/" alt="My music shop">
									<img alt src="images/portfolio/mshop.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Développement web</h6>								
								<a href="http://developpementweb.gabriel-cassano.be/" alt="Développement web">
									<img alt src="images/portfolio/dweb.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>IT solutions</h6>								
								<a href="http://itsolutions.gabriel-cassano.be/" alt="IT solutions">
									<img alt src="images/portfolio/it.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Passionate tchat</h6>								
								<a href="http://passionatetchat.gabriel-cassano.be/" alt="Passionate tchat">
									<img alt src="images/portfolio/tchat.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>My life projects</h6>								
								<a href="http://myprofile.gabriel-cassano.be/" alt="My profile">
									<img alt src="images/portfolio/profile.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>The History Of Metal</h6>								
								<a href="http://historyofmetal.gabriel-cassano.be/" alt="The history of metal">
									<img alt src="images/portfolio/history.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Start Company</h6>								
								<a href="http://startcompany.gabriel-cassano.be/" alt="Start company">
									<img alt src="images/portfolio/sc.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Les métiers de l'informatique</h6>								
								<a href="http://metiersinformatique.gabriel-cassano.be/" alt="Les métiers de l'informatique">
									<img alt src="images/portfolio/metiers.jpg" />								
								</a>
							</div>
						</div>
						
						<div className="columns portfolio-item">
							<div> 
								<h6>Movies list</h6>								
								<a href="http://movieslist.gabriel-cassano.be/" alt="Movies list">
									<img alt src="images/portfolio/list.jpg" />								
								</a>
							</div>
						</div>
					</div> 
				</div> 
			</div> 
      </section> 
	  }     
      </React.Fragment>
    );
  }
}
